import SVG from "components/SVG";
import { FC } from "react";

interface PageEmptyStateProps {
  iconSrc?: string;
  title?: string;
  text?: string;
}

const PageEmptyState: FC<PageEmptyStateProps> = ({
  title,
  text,
  iconSrc = "/svg/dataState/no-plan.svg",
}) => (
  <div className="flex w-full flex-1 flex-col items-center justify-center">
    <SVG src={iconSrc} width={400} height={320} />
    {title && <h3 className="text-center text-lg font-semibold">{title}</h3>}
    {text && <p className="text-center">{text}</p>}
  </div>
);

export default PageEmptyState;
